export * from "./v6";

import {
  ActiveSelection,
  FabricCanvas,
  FabricEllipse,
  FabricGroup,
  FabricImage,
  FabricIText,
  FabricObject,
  FabricPath,
  FabricRect,
} from "./v6";

[
  ActiveSelection,
  FabricCanvas,
  FabricEllipse,
  FabricImage,
  FabricGroup,
  FabricIText,
  FabricObject,
  FabricPath,
  FabricRect,
].forEach((cls) => {
  cls.ownDefaults = {
    ...cls.ownDefaults,
    cornerStyle: "circle",
    cornerSize: 16,
    cornerStrokeWidth: 1,
    objectCaching: false,
  };
});

import { setObjectPosition } from "../utils";

ActiveSelection.prototype.setPosition = function (
  this: ActiveSelection,
  key: "x" | "y" | { x: number; y: number },
  value?: number,
) {
  if (key instanceof Object) this.set(key);
  else this.set({ key: value });
  setObjectPosition(this, key, value);
};
